import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login, loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome to LOOXS");
      nav(["staff","manager","owner"].includes(u.role) ? "/admin" : "/account");
    } catch { toast.error("Invalid email or password"); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-8 pt-24 pb-24" style={{ background: "#efe7d7" }}>
      <div className="max-w-md w-full text-ink">
        <div className="text-center mb-12">
          <p className="text-[10px] tracking-luxury uppercase text-goldDark mb-4">The Members' Door</p>
          <h1 className="font-editorial text-5xl">Sign in</h1>
          <div className="rule-gold w-16 mx-auto mt-6" />
        </div>
        <form onSubmit={submit} className="space-y-8">
          <label className="block">
            <span className="text-[10px] tracking-widest-plus uppercase text-ink/60">Email</span>
            <input data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
              className="w-full border-b border-ink/25 focus:border-goldDark py-2 outline-none bg-transparent text-ink" />
          </label>
          <label className="block">
            <span className="text-[10px] tracking-widest-plus uppercase text-ink/60">Password</span>
            <input data-testid="login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)}
              className="w-full border-b border-ink/25 focus:border-goldDark py-2 outline-none bg-transparent text-ink" />
          </label>
          <button data-testid="login-submit" disabled={busy} className="w-full bg-ink text-ivory py-4 text-[11px] tracking-widest-plus uppercase hover:bg-goldDark transition-colors duration-500 disabled:opacity-40">
            {busy ? "Entering…" : "Enter"}
          </button>
        </form>

        <div className="my-8 flex items-center gap-4 text-[10px] tracking-widest-plus uppercase text-ink/40">
          <div className="flex-1 h-px bg-ink/15" /> or <div className="flex-1 h-px bg-ink/15" />
        </div>
        <button data-testid="login-google" onClick={loginWithGoogle}
          className="w-full border border-ink/25 py-4 text-[11px] tracking-widest-plus uppercase text-ink hover:border-goldDark hover:text-goldDark transition-colors duration-500 flex items-center justify-center gap-3 bg-white">
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.72 1.22 9.22 3.6l6.85-6.85C36.24 2.28 30.5 0 24 0 14.62 0 6.5 5.38 2.56 13.22l7.98 6.19C12.46 13.66 17.72 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.42-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59A14.34 14.34 0 0 1 9.75 24c0-1.6.27-3.14.78-4.59l-7.98-6.19A23.9 23.9 0 0 0 0 24c0 3.88.92 7.55 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.31-8.16 2.31-6.28 0-11.61-4.16-13.53-9.86l-7.97 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          Continue with Google
        </button>
        <p className="mt-8 text-center text-sm text-ink/60">
          No account yet? <Link to="/signup" className="text-goldDark link-draw">Register</Link>
        </p>
        <div className="mt-12 p-6 border border-ink/10 text-[11px] tracking-widest-plus uppercase text-ink/50" style={{ background: "#e5dbc7" }}>
          <p className="text-goldDark mb-2">Demo</p>
          <p>Admin · admin@looxs.com / admin123</p>
          <p>Client · demo@looxs.com / demo123</p>
        </div>
      </div>
    </div>
  );
}
